import React, { useEffect, useState } from 'react'
import { Table, Button, Modal, Input, Header, Form } from 'semantic-ui-react'
import { toast } from 'react-toastify'
import useAxios from '../../../lib/auth/useAxios'
import MickeyTable from '../../../components/MickeyTable/MickeyTable'
import env from '../../../env'
import BuyerQuotesRow from './BuyerQuotesRow'
import { useSelector } from 'react-redux'

function BuyerQuotes(props) {
  const { buyer, setCurrentTab } = props
  const tenant = useSelector((state) => {
    return state?.globals?.tenant
  })
  const axios = useAxios()
  const [rfqs, setRfqs] = useState([])
  const [loading, setLoading] = useState(true)

  const fetchRFQs = async () => {
    try {
      const response = await axios.get('/main/rfq-items/', {
        params: { active: true, status: 'pending', buyer_id: buyer?.id, buyer_submitted: false },
      })
      setRfqs(response.data.results)
      setLoading(false)
    } catch (error) {
      toast.error('Error fetching RFQs')
      setLoading(false)
    }
  }

  useEffect(() => {
    setCurrentTab('quotes')
    fetchRFQs()
  }, [])

  const handleSubmitQuote = async (rfq_item_id, price, quantity) => {
    if (!price || !quantity) {
      toast.error('Please enter a price and quantity')
      return
    }

    try {
      await axios.post(`/main/rfq-items/${rfq_item_id}/submit_buyer_quote/`, {
        price: price,
        quantity: quantity,
      })
      toast.success('Quote submitted successfully')
      fetchRFQs()
    } catch (error) {
      toast.error('Error submitting quote')
    }
  }

  return (
    <div style={{ padding: '20px' }}>
      <Header as="h2" style={{ padding: '20px 20px 0 20px' }}>
        Quote Requests
      </Header>
      <MickeyTable
        headerRow={[
          'RFQ Number',
          'Product',
          'Price',
          'Quantity',
          'Unit',
          'Actions',
        ]}
        loaded={!loading}
        data={rfqs}
        emptyIcon={'file'}
        emptyMessage={'Requests for Quote will populate here'}
        renderBodyRow={(rfq, index) => (
          <BuyerQuotesRow
            key={rfq.id}
            rfq={rfq}
            onSubmit={handleSubmitQuote}
          />
        )}
        style={{ marginTop: '5px', margin: '10px' }}
        sticky
      />
    </div>
  )
}

export default BuyerQuotes
